export const LIB_VERSION = '0.12.1'
